<h2 style="display: flex; align-items: center">Dokumente &nbsp;&nbsp;<img style="cursor: pointer" (click)="showHint()" src="assets/info-i.png"/>
  <span class="grey-subtext padding-left-10">(optional)</span> </h2>

<div class="box has-advanced-upload {{fileHovered ? 'is-dragover' :''}}" *ngIf="isAdvancedUpload()"
     [class.no-drop]="!canDrop"
     (dragenter)="onFileDragStart($event)"
     (dragend)="onFileDragEnd($event)"
     (dragexit)="onFileDragEnd($event)"
     (dragleave)="onFileDragEnd($event)"
     (dragstart)="onFileDragStart($event)"
     (dragover)="onFileDragStart($event)"
     (drag)="fileHovered = true;"
     (drop)="onFileDropped($event)">
  <div class="box__input">
    <mat-icon color="primary">add</mat-icon>
    <br/>
    <br/>
    <span style="font-size: small" class="mat-typography">Ziehen Sie einfach ein oder mehrere Ihrer Dokumente auf diese Fläche</span>
  </div>
</div>

<div class="w-100 text-center mb" style="margin-top: 2.5rem">
  <input class="box__file" type="file" id="file" data-multiple-caption="{count} files selected" multiple
         accept="image/*,.pdf"
         (change)="fileSelected($event)"/>
  <label for="file">
    <div class="mat-focus-indicator mat-flat-button mat-button-base mat-primary" color="primary">Datei auswählen</div>
  </label>
  <br/>
  <br/>
  <span class="mat-typography">Bitte beachten Sie, dass nur Bild- oder PDF-Dateien bis insgesamt 100MB hochgeladen werden können.</span>
</div>


<h3 *ngIf="files?.length > 0">Hochgeladene Dokumente</h3>
<div class="documents-grid" id="documentlist" #documentlist>
  <div class="uploaded-file-wrapper mat-typography" *ngFor="let file of files">
    <div class="uploaded-file">
      <div class="preview-image">
        <div class="full-height-width" [ngStyle]="{'background': ' url(' + file.rawUrl  + ') no-repeat center center'}" [style.background-image]="'url('+file.url+')'" *ngIf="isImage(file)"></div>
        <iframe [src]="file.url" height="400vh" *ngIf="!isImage(file)"></iframe>
      </div>
      <a [href]="file.url" target="_blank">
        <div class="open"><mat-icon>fullscreen</mat-icon></div>
      </a>
      <div class="remove" (click)="remove(file.randomId)">
        <mat-icon>remove</mat-icon>
      </div>
    </div>
    {{file.file.name}}
  </div>
</div>
